$(function () {
  // 100vh
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');

  /* top slide */
  const breakPoint = window.matchMedia('(min-width: 769px)');
  var slidesCount = $('.top_slide .swiper-slide').length;
  var top_slide = new Swiper('.top_slide .swiper-container', {
    loop: slidesCount > 1,
    speed: 600,
    watchOverflow: true,
    slidesPerView: 1,
    effect: 'fade',
    coverflowEffect: {
      rotate: 0,
      slideShadows: false
    },
    autoplay: {
      delay: 10000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination'
    },
    on: {
      init: function () {
        const self = this;
        if (breakPoint.matches) {
          const pcHideIndex = $.map($(".swiper-slide.pc_hide"), (element, i) => { return $(element).attr('data-swiper-slide-index') })
          const removeIndexes = [...new Set(pcHideIndex)]
          self.removeSlide(removeIndexes)
        }
      }
    }
  });
  var topics = new Swiper('.slide_topics .swiper-container', {
    loop: true,
    speed: 600,
    slidesPerView: 1.2,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    watchSlidesVisibility: true,
    observer: true,
    observeParents: true,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: false
    },
    on: {
      beforeLoopFix: function () {
        $(".swiper-slide").removeClass("item");
      }
    },
    breakpoints: {
      767: {
        slidesPerView: 2.4,
        slidesOffsetBefore: 60,
      },
      1025: {
        slidesPerView: 3,
        slidesOffsetBefore: 0
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination'
    }
  });

  /* article slide */
  var articleCount = $('.product_article .product_slide .swiper-slide').length;
  var article_slide = new Swiper('.product_article .product_slide .swiper-container', {
    loop: articleCount > 1,
    speed: 600,
    watchOverflow: true,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  var slide_thumb = new Swiper('.product_article .product_thumbnail .swiper-container', {
    slidesPerView: 1,
    loop: articleCount > 1,
    effect: 'fade',
    speed: 600,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  if ($(".product_article .product_thumbnail").length) {
    article_slide.controller.control = slide_thumb;
    slide_thumb.controller.control = article_slide;
  }
  /* use thanks subscribe */
  /* recommend slide */
  var recommendCount = $('.cart_recommend .swiper-container >.swiper-wrapper >.swiper-slide').length;
  var margin = 0;
  if (recommendCount > 1) {
    margin = 20;
  }
  var cart_recommend = new Swiper('.cart_recommend .swiper-container', {
    loop: false,
    watchOverflow: true,
    speed: 600,
    slidesPerView: 1.2,
    spaceBetween: margin,
    slidesOffsetBefore: margin,
    slidesOffsetAfter: margin,
    slideToClickedSlide: false,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: false
    },
    breakpoints: {
      520: {
        slidesPerView: 1.5,
        slidesOffsetBefore: margin,
        slidesOffsetAfter: margin
      },
      767: {
        loop: false,
        slidesPerView: 1.8,
        spaceBetween: 20,
        slidesOffsetBefore: margin,
        slidesOffsetAfter: margin
      },
      1025: {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 30,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination'
    }
  });

  /* scroll animation */
  $(window).on('load shopify:section:load', function () {
    const fedein = document.querySelectorAll(".item");
    const observer = new IntersectionObserver(fadein);
    fedein.forEach(function (item) {
      observer.observe(item);
    });

    function fadein(entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          $(entry.target).delay(i * 100).queue(function (next) {
            $(entry.target).addClass("is-view");
            next();
          });
        }
      });
    }
  });

  /* menu */
  $(".header_menu.js-show-menu").click(function () {
    if ($(this).hasClass("is-menu")) {
      $("#side_menu").fadeOut("slow");
    } else {
      $("#side_menu").fadeIn("slow").addClass("is-open");
    }
    $(this).toggleClass("is-menu");
  });
  $("main").click(function (event) {
    if ($(event.target).closest("#side_menu").length > 0) return;

    if ($("#side_menu").hasClass("is-open")) {
      $("#side_menu").fadeOut("slow").removeClass("is-open");
      $(".header_menu.js-show-menu").toggleClass("is-menu");
    }
  })
  window.addEventListener('resize', function(){  
    if (window.innerWidth < 1024) return;
    if ($("#side_menu").hasClass("is-open")) {
      $("#side_menu").fadeOut("slow").removeClass("is-open");
      $(".header_menu.js-show-menu").toggleClass("is-menu");
    }
  });


  /* pop magazine */
  // モーダルを開く関数
  const openMagazineModal = () => {
    try {
      $(".form_magazine .pop_magazine")
        .prependTo(".modal_magazine .inner")
        .hide()
        .fadeIn(300, () => {
          $(".modal_magazine").addClass("open");
        });
    } catch (error) {
      console.error("モーダルを開く処理でエラーが発生しました", error);
    }
  };

  // モーダルを閉じる関数
  const closeMagazineModal = () => {
    try {
      $(".modal_magazine")
        .removeClass("open")
        .delay(1000)
        .queue(function (next) {
          $(".modal_magazine .pop_magazine").prependTo(".form_magazine .inner");
          next();
        });
    } catch (error) {
      console.error("モーダルを閉じる処理でエラーが発生しました", error);
    }
  };

  // 外側クリックでモーダルを閉じる設定
  const closeMagazineModalOnOutsideClick = () => {
    try {
      $(document).on("click", (event) => {
        const modal = $(".modal_magazine");
        if (modal.hasClass("open") && !$(event.target).closest(".modal_magazine .inner").length) {
          closeMagazineModal();
        }
      });
    } catch (error) {
      console.error("モーダルの外側クリック処理でエラーが発生しました", error);
    }
  };

  // ボタンクリックイベント
  $(".btn_magazine, .btn_more.magazine").click((event) => {
    event.preventDefault();
    close_product_modal();
    openMagazineModal();
  });

  $(".modal_magazine .close_btn").click(() => {
    closeMagazineModal();
  });

  // 外側クリックのイベントを有効化
  closeMagazineModalOnOutsideClick();


  /* reset form */
  $('a[href="#recover"]').click(function () {
    $("#recover").toggleClass("open");
    return false;
  });
  $("#recover .close_btn").click(function () {
    $("#recover").removeClass("open");
  });
  if ($("#recover .errors ul li").length) {
    var error_text = $("#recover .errors ul li").text();
    $('<div class="alert"><p>' + error_text + '</p></div>').appendTo("main");
  }
  if ($("#recover [role='status'] p").length) {
    $('<div class="alert"><p>メールを送信しました。</p></div>').appendTo("main");
  }

  /* Show/Hide product_bar btn */
  $(window).scroll(function () {
    var footBar = 0;
    if ($(window).innerHeight() < 750) {
      footBar = 95;
    }
    if ($(".product_bar").length) {
      // Check if we should show/hide product_bar based on footer position
      if ($("footer").length && $("footer").is(":visible")) {
        // If viewport has reached the top of footer, hide product_bar
        if ($(this).scrollTop() + $(window).height() > $("footer").offset().top) {
          $("section.product_bar").removeClass("on");
          $("section.product_bar").addClass("off");
        } else {
          // Otherwise, show product_bar if scrolled past initial threshold
          if ($(this).scrollTop() + $(window).innerHeight() > $(window).innerHeight() + footBar) {
            $("section.product_bar").addClass("on");
            $("section.product_bar").removeClass("off");
          } else {
            $("section.product_bar").removeClass("on");
          }
        }
      } else {
        // If no footer, use original logic
        if ($(this).scrollTop() + $(window).innerHeight() > $(window).innerHeight() + footBar) {
          $("section.product_bar").addClass("on");
        } else {
          $("section.product_bar").removeClass("on");
        }
      }
    }
  });

  /* copy btn */
  var clipboard = new ClipboardJS(".copy");
  clipboard.on('success', (e) => {
    var title = "コピー"
    if (typeof e.trigger.dataset.clipboardTitle == 'string') {
      title = e.trigger.dataset.clipboardTitle;
    } else {
      title = e.trigger.outerText;
    }
    $('<div class="alert"><p>' + title + 'しました！</p></div>').appendTo("main");
  });

  /* magazine check */
  $("#marketing").click(function () {
    const willChangeVal =
      $("[name='customer[accepts_marketing]']").val() === "true"
        ? "false"
        : "true";
    $("[name='customer[accepts_marketing]']").val(willChangeVal);
  });

  /* language change */
  $(".language_select").change(function () {
    if ($(this).val() != '') {
      window.location.href = $(this).val();
    }
  });
});

function close_product_modal() {
  if ($('.modal_classic').hasClass('open')) {
    $(".modal_classic").removeClass("open").fadeOut();
    document.body.style.overflow = 'visible';
  }
}
